import React from 'react';
import { motion } from 'framer-motion';
import { TECH_STACK } from '../data/techStack';

const Skills: React.FC = () => {
  return (
    <section className="screen-line-after px-4 py-12">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        <h2 className="text-lg font-semibold text-foreground mb-6">Tech Stack</h2>
        <div className="flex flex-wrap gap-3">
          {TECH_STACK.map((tech, i) => (
            <motion.div
              key={tech.title}
              initial={{ opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: i * 0.03 }}
              viewport={{ once: true }}
              className="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm text-muted-foreground border border-border hover:text-foreground hover:bg-accent transition-colors duration-200"
            >
              <span>{tech.emoji}</span>
              <span>{tech.title}</span>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Skills;